import { render, staticRenderFns } from "./Cell.vue?vue&type=template&id=f4f786c2&"
import script from "./Cell.vue?vue&type=script&lang=ts&"
export * from "./Cell.vue?vue&type=script&lang=ts&"
import style0 from "./Cell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports